import { render, staticRenderFns } from "./AnalyticsRewards.vue?vue&type=template&id=67d35f34&"
import script from "./AnalyticsRewards.vue?vue&type=script&setup=true&lang=js&"
export * from "./AnalyticsRewards.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports